import React, { type PropsWithChildren } from 'react';
import withContext from '../../../lib/withContext';
import { LogoMakerProvider, type LogoMakerProviderProps } from './LogoMakerContext';

/**
 * Combines both contexts needed by LogoMaker composites:
 * 1. General header context (provided by withContext)
 * 2. LogoMaker-specific context (LogoMakerProvider)
 *
 * Usage:
 *   <LogoMakerProviders user={...} rollouts={...} isTransparent>
 *     <LoggedOutLogoMaker showSeoLinks />
 *   </LogoMakerProviders>
 */
const LogoMakerProvidersInner = ({
    children,
    showBackButton,
    integration,
    isTransparent,
    isSticky,
}: PropsWithChildren<LogoMakerProviderProps>) => (
    <LogoMakerProvider
        showBackButton={showBackButton}
        integration={integration}
        isTransparent={isTransparent}
        isSticky={isSticky}
    >
        {children}
    </LogoMakerProvider>
);

const LogoMakerProviders = withContext(LogoMakerProvidersInner);

export default LogoMakerProviders;
